jQuery(function() {
    function onYaPayLoad() {
        const renderElement = $('#yandex_split_detail_product');

        if (renderElement.length === 0) {
            return;
        }

        var price = renderElement.attr('data-price') || 0;
        const YaPay = window.YaPay;

        // Данные платежа
        const paymentData = {
            env: 'PRODUCTION',
            version: 4,
            currencyCode: 'RUB',
            merchantId: 'de5da2c1-12db-4179-b02a-11b580eab658',
            totalAmount: price,
            availablePaymentMethods: ['SPLIT']
        };

        function onPayButtonClick() {}

        // eslint-disable-next-line no-unused-vars
        function onFormOpenError(reason) {}

        // Создаем платежную сессию
        YaPay.createSession(paymentData, { onPayButtonClick: onPayButtonClick, onFormOpenError: onFormOpenError })
            .then(function(paymentSession) {
                paymentSession.mountWidget(document.querySelector('#yandex_split_detail_product'), {
                    widgetType: YaPay.WidgetType.Ultimate,
                    widgetTheme: YaPay.WidgetTheme.Light,
                    borderRadius: 10,
                    padding: YaPay.WidgetPaddingType.Default,
                    withOutline: true,
                    widgetBackground: YaPay.WidgetBackgroundType.Saturated,
                    hideWidgetHeader: false,
                    widgetSize: YaPay.WidgetSize.Medium
                });
            })
            .catch(function(err) {
                console.log(err);
            });
    }

    setTimeout(function() {
        onYaPayLoad();
    }, 1000);
});



// WEBPACK FOOTER //
// ./blocks/product-split/product-split.js